import React from 'react'

import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import BrandEditRoutes from './routes'

const BrandEdit = () => {
  const { brandId } = useNumericParams()

  useReduxAction(
    'brands',
    'loadBrand',
    {
      entityId: brandId,
      ...defaultRequestOptions.brand,
    },
    [brandId],
    {
      dispatchAction: (action, requestOptions) => action(brandId, requestOptions),
      shouldPerformFn: ({ loading }) => brandId && !loading,
    },
  )

  return (
    <BrandEditRoutes brandId={brandId} />
  )
}

export default BrandEdit
